import { Badge, Checkbox, Flex } from "@chakra-ui/react";
import TableCell from "components/elements/TableCell";
import { useNavigate } from "react-router-dom";
import { useCustomFormats } from "hooks/useCustomFormat";

interface FormattedContent {
  type: string;
  value: string | number | boolean;
  rawValue: any;
}

export function getFormattedContent(
  type: string,
  value: any,
  loan?: any,
  selectedRows?: any[],
  formatDate?: (date: any) => string,
  formatCurrency?: (value: any, format?: "short" | "long") => string
): FormattedContent {
  let formattedValue: string | number | boolean = value || "Not Provided";

  switch (type) {
    case "location":
      formattedValue = value?.formatted ?? "Not Provided";
      break;
    case "company":
      formattedValue = value.company.name;
      break;
    case "date":
      formattedValue = formatDate ? formatDate(value) : "Not Provided";
      break;
    case "dollar":
      formattedValue = formatCurrency ? formatCurrency(value, "short") : "Not Provided";
      break;
    case "loan_type":
      formattedValue = value.title;
      break;
    case "percentage":
      formattedValue = value ? `${value}%` : "Not Provided";
      break;
    case "property":
      formattedValue = value ? value.name : "Not Provided";
      break;
    case "status":
      formattedValue = loan?.status.label ?? "Not Provided";
      break;
    case "radioFloatingRate":
      formattedValue =
        value?.InterestRate !== undefined ? `${value.InterestRate}%` : "Not Provided";
      break;
    case "Select":
      formattedValue = selectedRows?.find((row: any) => row === loan?.id) ? true : false;
      break;
    case "loan_id":
      formattedValue = `#${value.split("-")[0]}`;
      break;
  }

  return {
    type,
    value: formattedValue,
    rawValue: value,
  };
}

export function FormatTableCell({
  loan,
  type,
  value,
  onRowSelect,
  selectedRows,
}: {
  loan: any;
  type: string;
  value: any;
  onRowSelect?: any;
  selectedRows?: any;
}) {
  const navigate = useNavigate();
  const { formatDate, formatCurrency } = useCustomFormats();

  const viewLoan = (id: string) => {
    navigate(`/loans/${id}`);
  };

  const handleLoanClick = () => {
    viewLoan(loan.id);
  };

  const handleRowSelect = (id: string) => {
    onRowSelect(id);
  };

  const formattedContent = getFormattedContent(
    type,
    value,
    loan,
    selectedRows,
    formatDate,
    formatCurrency
  );
  let content: string | number | boolean | JSX.Element = formattedContent.value;

  // Handle special cases that need JSX elements
  if (type === "status") {
    content = (
      <Badge fontWeight="600" bg={`${loan.status.color}15`} color={loan.status.color ?? "#000000"}>
        {formattedContent.value}
      </Badge>
    );
  } else if (type === "Select") {
    content = (
      <Flex alignItems="center">
        <Checkbox
          colorScheme="teal"
          key={loan.id}
          isChecked={!!formattedContent.value}
          onChange={() => handleRowSelect(loan.id)}
        />
      </Flex>
    );
  }

  return (
    <TableCell
      onClick={type === "Select" ? undefined : handleLoanClick}
      color={content === "Not Provided" ? "gray.200" : "black"}
      maxW={type === "status" ? "auto" : "140px"}
    >
      {content}
    </TableCell>
  );
}
